export default {
    name: 'layoutNonScroll',
    state: {
        layoutNonScroll: false
    },
    getters: {
        getLayoutNonScroll: state => {
            return state.layoutNonScroll
        },
    },
    mutations: {
        LAYOUTNONSCROLL: (state, payload) => {
            state.layoutNonScroll = payload;
        }
    },
    actions: {
        SET_LAYOUTNONSCROLL(store, payload) {
            //console.log('payload');
            //console.log(payload);
            store.commit('LAYOUTNONSCROLL', payload)
        }
    }
}